import { FETCH_KB_DATA, DELETE_KB_DATA } from "./actionTypes";
import { INTERNAL_KB_TYPE } from "../constants";

const initialStore = {
    knowledge_base_id: '',
    link: '',
    title: '',
    logoUrl: '',
    setupBy: {
        id: '',
        name: ''
    },
    setupAt: '',
    onceFetched: false,
    isInternal: false
}


export const kbReducer = (store = initialStore, action) => {
    const { type, payload } = action;

    switch (type) {
        case `${FETCH_KB_DATA}_SUCCESS`:{
            const { knowledge_base_id, link, title, setup_by, setup_at, logo_url, type } = payload || {};
            return {
                ...store,
                knowledge_base_id,
                link,
                title,
                setupAt: setup_at,
                setupBy: setup_by,
                logoUrl: logo_url,
                onceFetched: true,
                isInternal: type === INTERNAL_KB_TYPE
            }
        };
        case `${DELETE_KB_DATA}_SUCCESS`: {
            return {
                ...initialStore,
                onceFetched: true
            };
        }

        default: return store;
    }
}